/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-bitwise */
// @ts-nocheck
// This file was auto-generated using the command: pbjs scribble.proto --ts protobuf-util.ts
export const enum PathType {
  M = 'M',
  L = 'L',
  Q = 'Q'
}

export const encodePathType: { [key: string]: number } = {
  M: 1,
  L: 2,
  Q: 3
};

export const decodePathType: { [key: number]: PathType } = {
  1: PathType.M,
  2: PathType.L,
  3: PathType.Q
};

export interface PathCommand {
  type?: PathType;
  values?: number[];
}

function _encodePathCommand(message: PathCommand, bb: ByteBuffer): void {
  // optional PathType type = 1;
  let $type = message.type;
  if ($type !== undefined) {
    writeVarint32(bb, 8);
    writeVarint32(bb, encodePathType[$type]);
  }

  // repeated float values = 2;
  let array$values = message.values;
  if (array$values !== undefined) {
    let packed = popByteBuffer();
    for (let value of array$values) {
      writeFloat(packed, value);
    }
    writeVarint32(bb, 18);
    writeVarint32(bb, packed.offset);
    writeByteBuffer(bb, packed);
    pushByteBuffer(packed);
  }
}

function _decodePathCommand(bb: ByteBuffer): PathCommand {
  let message: PathCommand = {} as any;

  end_of_message: while (!isAtEnd(bb)) {
    let tag = readVarint32(bb);

    switch (tag >>> 3) {
      case 0:
        break end_of_message;

      // optional PathType type = 1;
      case 1: {
        message.type = decodePathType[readVarint32(bb)];
        break;
      }

      // repeated float values = 2;
      case 2: {
        let values = message.values || (message.values = []);
        if ((tag & 7) === 2) {
          let outerLimit = pushTemporaryLength(bb);
          while (!isAtEnd(bb)) {
            values.push(readFloat(bb));
          }
          bb.limit = outerLimit;
        } else {
          values.push(readFloat(bb));
        }
        break;
      }

      default:
        skipUnknownField(bb, tag & 7);
    }
  }

  return message;
}

export interface PathShape {
  left?: number;
  top?: number;
  width?: number;
  height?: number;
  angle?: number;
  scaleX?: number;
  scaleY?: number;
  skewX?: number;
  skewY?: number;
  flipY?: boolean;
  flipX?: boolean;
  locked?: boolean;
  stroke?: string;
  stroke_width?: number;
  path?: PathCommand[];
}

export function encodePathShape(message: PathShape): Uint8Array {
  let bb = popByteBuffer();
  _encodePathShape(message, bb);
  return toUint8Array(bb);
}

function _encodePathShape(message: PathShape, bb: ByteBuffer): void {
  // optional double left = 1;
  let $left = message.left;
  if ($left !== undefined) {
    writeVarint32(bb, 9);
    writeDouble(bb, $left);
  }

  // optional double top = 2;
  let $top = message.top;
  if ($top !== undefined) {
    writeVarint32(bb, 17);
    writeDouble(bb, $top);
  }

  // optional double width = 3;
  let $width = message.width;
  if ($width !== undefined) {
    writeVarint32(bb, 25);
    writeDouble(bb, $width);
  }

  // optional double height = 4;
  let $height = message.height;
  if ($height !== undefined) {
    writeVarint32(bb, 33);
    writeDouble(bb, $height);
  }

  // optional double angle = 5;
  let $angle = message.angle;
  if ($angle !== undefined) {
    writeVarint32(bb, 41);
    writeDouble(bb, $angle);
  }

  // optional double scaleX = 6;
  let $scaleX = message.scaleX;
  if ($scaleX !== undefined) {
    writeVarint32(bb, 49);
    writeDouble(bb, $scaleX);
  }

  // optional double scaleY = 7;
  let $scaleY = message.scaleY;
  if ($scaleY !== undefined) {
    writeVarint32(bb, 57);
    writeDouble(bb, $scaleY);
  }

  // optional double skewX = 8;
  let $skewX = message.skewX;
  if ($skewX !== undefined) {
    writeVarint32(bb, 65);
    writeDouble(bb, $skewX);
  }

  // optional double skewY = 9;
  let $skewY = message.skewY;
  if ($skewY !== undefined) {
    writeVarint32(bb, 73);
    writeDouble(bb, $skewY);
  }

  // optional bool flipY = 10;
  let $flipY = message.flipY;
  if ($flipY !== undefined) {
    writeVarint32(bb, 80);
    writeByte(bb, $flipY ? 1 : 0);
  }

  // optional bool flipX = 11;
  let $flipX = message.flipX;
  if ($flipX !== undefined) {
    writeVarint32(bb, 88);
    writeByte(bb, $flipX ? 1 : 0);
  }

  // optional bool locked = 12;
  let $locked = message.locked;
  if ($locked !== undefined) {
    writeVarint32(bb, 96);
    writeByte(bb, $locked ? 1 : 0);
  }

  // optional string stroke = 13;
  let $stroke = message.stroke;
  if ($stroke !== undefined) {
    writeVarint32(bb, 106);
    writeString(bb, $stroke);
  }

  // optional uint32 stroke_width = 14;
  let $stroke_width = message.stroke_width;
  if ($stroke_width !== undefined) {
    writeVarint32(bb, 112);
    writeVarint32(bb, $stroke_width);
  }

  // repeated PathCommand path = 15;
  let array$path = message.path;
  if (array$path !== undefined) {
    for (let value of array$path) {
      writeVarint32(bb, 122);
      let nested = popByteBuffer();
      _encodePathCommand(value, nested);
      writeVarint32(bb, nested.limit);
      writeByteBuffer(bb, nested);
      pushByteBuffer(nested);
    }
  }
}

export function decodePathShape(binary: Uint8Array): PathShape {
  return _decodePathShape(wrapByteBuffer(binary));
}

function _decodePathShape(bb: ByteBuffer): PathShape {
  let message: PathShape = {} as any;

  end_of_message: while (!isAtEnd(bb)) {
    let tag = readVarint32(bb);

    switch (tag >>> 3) {
      case 0:
        break end_of_message;

      // optional double left = 1;
      case 1: {
        message.left = readDouble(bb);
        break;
      }

      // optional double top = 2;
      case 2: {
        message.top = readDouble(bb);
        break;
      }

      // optional double width = 3;
      case 3: {
        message.width = readDouble(bb);
        break;
      }

      // optional double height = 4;
      case 4: {
        message.height = readDouble(bb);
        break;
      }

      // optional double angle = 5;
      case 5: {
        message.angle = readDouble(bb);
        break;
      }

      // optional double scaleX = 6;
      case 6: {
        message.scaleX = readDouble(bb);
        break;
      }

      // optional double scaleY = 7;
      case 7: {
        message.scaleY = readDouble(bb);
        break;
      }

      // optional double skewX = 8;
      case 8: {
        message.skewX = readDouble(bb);
        break;
      }

      // optional double skewY = 9;
      case 9: {
        message.skewY = readDouble(bb);
        break;
      }

      // optional bool flipY = 10;
      case 10: {
        message.flipY = !!readByte(bb);
        break;
      }

      // optional bool flipX = 11;
      case 11: {
        message.flipX = !!readByte(bb);
        break;
      }

      // optional bool locked = 12;
      case 12: {
        message.locked = !!readByte(bb);
        break;
      }

      // optional string stroke = 13;
      case 13: {
        message.stroke = readString(bb, readVarint32(bb));
        break;
      }

      // optional uint32 stroke_width = 14;
      case 14: {
        message.stroke_width = readVarint32(bb) >>> 0;
        break;
      }

      // repeated PathCommand path = 15;
      case 15: {
        let limit = pushTemporaryLength(bb);
        let values = message.path || (message.path = []);
        values.push(_decodePathCommand(bb));
        bb.limit = limit;
        break;
      }

      default:
        skipUnknownField(bb, tag & 7);
    }
  }

  return message;
}

export interface Long {
  low: number;
  high: number;
  unsigned: boolean;
}

interface ByteBuffer {
  bytes: Uint8Array;
  offset: number;
  limit: number;
}

function pushTemporaryLength(bb: ByteBuffer): number {
  let length = readVarint32(bb);
  let limit = bb.limit;
  bb.limit = bb.offset + length;
  return limit;
}

function skipUnknownField(bb: ByteBuffer, type: number): void {
  switch (type) {
    case 0:
      while (readByte(bb) & 0x80) {
        // @ts-ignore
      }
      break;
    case 2:
      skip(bb, readVarint32(bb));
      break;
    case 5:
      skip(bb, 4);
      break;
    case 1:
      skip(bb, 8);
      break;
    default:
      throw new Error('Unimplemented type: ' + type);
  }
}

// The code below was modified from https://github.com/protobufjs/bytebuffer.js
// which is under the Apache License 2.0.

let f32 = new Float32Array(1);
let f32_u8 = new Uint8Array(f32.buffer);

let f64 = new Float64Array(1);
let f64_u8 = new Uint8Array(f64.buffer);

let bbStack: ByteBuffer[] = [];

function popByteBuffer(): ByteBuffer {
  const bb = bbStack.pop();
  if (!bb) return { bytes: new Uint8Array(64), offset: 0, limit: 0 };
  bb.offset = bb.limit = 0;
  return bb;
}

function pushByteBuffer(bb: ByteBuffer): void {
  bbStack.push(bb);
}

function wrapByteBuffer(bytes: Uint8Array): ByteBuffer {
  return { bytes, offset: 0, limit: bytes.length };
}

function toUint8Array(bb: ByteBuffer): Uint8Array {
  let bytes = bb.bytes;
  let limit = bb.limit;
  return bytes.length === limit ? bytes : bytes.subarray(0, limit);
}

function skip(bb: ByteBuffer, offset: number): void {
  if (bb.offset + offset > bb.limit) {
    throw new Error('Skip past limit');
  }
  bb.offset += offset;
}

function isAtEnd(bb: ByteBuffer): boolean {
  return bb.offset >= bb.limit;
}

function grow(bb: ByteBuffer, count: number): number {
  let bytes = bb.bytes;
  let offset = bb.offset;
  let limit = bb.limit;
  let finalOffset = offset + count;
  if (finalOffset > bytes.length) {
    let newBytes = new Uint8Array(finalOffset * 2);
    newBytes.set(bytes);
    bb.bytes = newBytes;
  }
  bb.offset = finalOffset;
  if (finalOffset > limit) {
    bb.limit = finalOffset;
  }
  return offset;
}

function advance(bb: ByteBuffer, count: number): number {
  let offset = bb.offset;
  if (offset + count > bb.limit) {
    throw new Error('Read past limit');
  }
  bb.offset += count;
  return offset;
}

function readString(bb: ByteBuffer, count: number): string {
  // Sadly a hand-coded UTF8 decoder is much faster than subarray+TextDecoder in V8
  let offset = advance(bb, count);
  let fromCharCode = String.fromCharCode;
  let bytes = bb.bytes;
  let invalid = '\uFFFD';
  let text = '';

  for (let i = 0; i < count; i++) {
    let c1 = bytes[i + offset],
      c2: number,
      c3: number,
      c4: number,
      c: number;

    // 1 byte
    if ((c1 & 0x80) === 0) {
      text += fromCharCode(c1);
    }

    // 2 bytes
    else if ((c1 & 0xe0) === 0xc0) {
      if (i + 1 >= count) text += invalid;
      else {
        c2 = bytes[i + offset + 1];
        if ((c2 & 0xc0) !== 0x80) text += invalid;
        else {
          c = ((c1 & 0x1f) << 6) | (c2 & 0x3f);
          if (c < 0x80) text += invalid;
          else {
            text += fromCharCode(c);
            i++;
          }
        }
      }
    }

    // 3 bytes
    else if ((c1 & 0xf0) == 0xe0) {
      if (i + 2 >= count) text += invalid;
      else {
        c2 = bytes[i + offset + 1];
        c3 = bytes[i + offset + 2];
        if (((c2 | (c3 << 8)) & 0xc0c0) !== 0x8080) text += invalid;
        else {
          c = ((c1 & 0x0f) << 12) | ((c2 & 0x3f) << 6) | (c3 & 0x3f);
          if (c < 0x0800 || (c >= 0xd800 && c <= 0xdfff)) text += invalid;
          else {
            text += fromCharCode(c);
            i += 2;
          }
        }
      }
    }

    // 4 bytes
    else if ((c1 & 0xf8) == 0xf0) {
      if (i + 3 >= count) text += invalid;
      else {
        c2 = bytes[i + offset + 1];
        c3 = bytes[i + offset + 2];
        c4 = bytes[i + offset + 3];
        if (((c2 | (c3 << 8) | (c4 << 16)) & 0xc0c0c0) !== 0x808080)
          text += invalid;
        else {
          c =
            ((c1 & 0x07) << 0x12) |
            ((c2 & 0x3f) << 0x0c) |
            ((c3 & 0x3f) << 0x06) |
            (c4 & 0x3f);
          if (c < 0x10000 || c > 0x10ffff) text += invalid;
          else {
            c -= 0x10000;
            text += fromCharCode((c >> 10) + 0xd800, (c & 0x3ff) + 0xdc00);
            i += 3;
          }
        }
      }
    } else text += invalid;
  }

  return text;
}

function writeString(bb: ByteBuffer, text: string): void {
  // Sadly a hand-coded UTF8 encoder is much faster than TextEncoder+set in V8
  let n = text.length;
  let byteCount = 0;

  // Write the byte count first
  for (let i = 0; i < n; i++) {
    let c = text.charCodeAt(i);
    if (c >= 0xd800 && c <= 0xdbff && i + 1 < n) {
      c = (c << 10) + text.charCodeAt(++i) - 0x35fdc00;
    }
    byteCount += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }
  writeVarint32(bb, byteCount);

  let offset = grow(bb, byteCount);
  let bytes = bb.bytes;

  // Then write the bytes
  for (let i = 0; i < n; i++) {
    let c = text.charCodeAt(i);
    if (c >= 0xd800 && c <= 0xdbff && i + 1 < n) {
      c = (c << 10) + text.charCodeAt(++i) - 0x35fdc00;
    }
    if (c < 0x80) {
      bytes[offset++] = c;
    } else {
      if (c < 0x800) {
        bytes[offset++] = ((c >> 6) & 0x1f) | 0xc0;
      } else {
        if (c < 0x10000) {
          bytes[offset++] = ((c >> 12) & 0x0f) | 0xe0;
        } else {
          bytes[offset++] = ((c >> 18) & 0x07) | 0xf0;
          bytes[offset++] = ((c >> 12) & 0x3f) | 0x80;
        }
        bytes[offset++] = ((c >> 6) & 0x3f) | 0x80;
      }
      bytes[offset++] = (c & 0x3f) | 0x80;
    }
  }
}

function writeByteBuffer(bb: ByteBuffer, buffer: ByteBuffer): void {
  let offset = grow(bb, buffer.limit);
  let from = bb.bytes;
  let to = buffer.bytes;

  // This for loop is much faster than subarray+set on V8
  for (let i = 0, n = buffer.limit; i < n; i++) {
    from[i + offset] = to[i];
  }
}

function readByte(bb: ByteBuffer): number {
  return bb.bytes[advance(bb, 1)];
}

function writeByte(bb: ByteBuffer, value: number): void {
  let offset = grow(bb, 1);
  bb.bytes[offset] = value;
}

function readFloat(bb: ByteBuffer): number {
  let offset = advance(bb, 4);
  let bytes = bb.bytes;

  // Manual copying is much faster than subarray+set in V8
  f32_u8[0] = bytes[offset++];
  f32_u8[1] = bytes[offset++];
  f32_u8[2] = bytes[offset++];
  f32_u8[3] = bytes[offset++];
  return f32[0];
}

function writeFloat(bb: ByteBuffer, value: number): void {
  let offset = grow(bb, 4);
  let bytes = bb.bytes;
  f32[0] = value;

  // Manual copying is much faster than subarray+set in V8
  bytes[offset++] = f32_u8[0];
  bytes[offset++] = f32_u8[1];
  bytes[offset++] = f32_u8[2];
  bytes[offset++] = f32_u8[3];
}

function readDouble(bb: ByteBuffer): number {
  let offset = advance(bb, 8);
  let bytes = bb.bytes;

  // Manual copying is much faster than subarray+set in V8
  f64_u8[0] = bytes[offset++];
  f64_u8[1] = bytes[offset++];
  f64_u8[2] = bytes[offset++];
  f64_u8[3] = bytes[offset++];
  f64_u8[4] = bytes[offset++];
  f64_u8[5] = bytes[offset++];
  f64_u8[6] = bytes[offset++];
  f64_u8[7] = bytes[offset++];
  return f64[0];
}

function writeDouble(bb: ByteBuffer, value: number): void {
  let offset = grow(bb, 8);
  let bytes = bb.bytes;
  f64[0] = value;

  // Manual copying is much faster than subarray+set in V8
  bytes[offset++] = f64_u8[0];
  bytes[offset++] = f64_u8[1];
  bytes[offset++] = f64_u8[2];
  bytes[offset++] = f64_u8[3];
  bytes[offset++] = f64_u8[4];
  bytes[offset++] = f64_u8[5];
  bytes[offset++] = f64_u8[6];
  bytes[offset++] = f64_u8[7];
}

function readVarint32(bb: ByteBuffer): number {
  let c = 0;
  let value = 0;
  let b: number;
  do {
    b = readByte(bb);
    if (c < 32) value |= (b & 0x7f) << c;
    c += 7;
  } while (b & 0x80);
  return value;
}

function writeVarint32(bb: ByteBuffer, value: number): void {
  value >>>= 0;
  while (value >= 0x80) {
    writeByte(bb, (value & 0x7f) | 0x80);
    value >>>= 7;
  }
  writeByte(bb, value);
}
